// DO NOT EDIT -- generated from fs/api/segment/operators.proto

import { BoolValue, BrowserValue, CustomFieldBoolValue, CustomFieldDateRangeValue, CustomFieldDateValue, CustomFieldFloatRangeValue, CustomFieldFloatValue, CustomFieldIntRangeValue, CustomFieldIntValue, CustomFieldIsSetValue, CustomFieldRepeatedFloatValue, CustomFieldRepeatedIntValue, CustomFieldRepeatedStringValue, DatalossTypeValue, DateRangeValue, DateValue, DeviceValue, DurationRangeValue, DurationValue, ErrorClickTypeValue, FloatRangeValue, FloatValue, NamedCustomEventValue, NativePlatformValue, NoneValue, NumericRangeValue, NumericValue, OSValue, PinchGestureTypeValue, PlatformValue, RepeatedFloatValue, RepeatedNamedElementValue, RepeatedNumericValue, RepeatedPageRefValue, RepeatedStringValue, SeenVisibilityTypeValue, SessionTypeValue, StringValue, SuspiciousActivityCategoryValue, SuspiciousActivityTypeValue, UrlValue } from './values.proto';

export interface ElementOperator {
  any?: NoneValue | null;
  text?: RepeatedStringValue | null;
  css?: RepeatedStringValue | null;
  cssIsNot?: RepeatedStringValue | null;
  /** matches the full canonicalized css string value exactly */
  exactCss?: RepeatedStringValue | null;
  cssSubstring?: RepeatedStringValue | null;
  /** matches retroactively using the current named element definition */
  withElementId?: RepeatedNamedElementValue | null;
  /** matches using the id directly against the single historically tagged named element */
  withHistoricalElementId?: RepeatedNamedElementValue | null;
  /** matches using the id directly against the single historically tagged named element */
  withoutHistoricalElementId?: RepeatedNamedElementValue | null;
  /** matches events that were tagged historically with a named element id */
  withSetHistoricalElementId?: NoneValue | null;
  /** matches events that were not tagged historically with a named element id */
  withUnsetHistoricalElementId?: NoneValue | null;
  textContainsToken?: RepeatedStringValue | null;
  textStartsWith?: RepeatedStringValue | null;
  textEndsWith?: RepeatedStringValue | null;
  textIsNot?: RepeatedStringValue | null;
  textNotContainsToken?: RepeatedStringValue | null;
  textContainsTokenStartsWith?: RepeatedStringValue | null;
}

export namespace ElementOperator {
  export enum operator {
    any = 1,
    text = 2,
    css = 3,
    cssIsNot = 16,
    /** matches the full canonicalized css string value exactly */
    exactCss = 15,
    cssSubstring = 17,
    /** matches retroactively using the current named element definition */
    withElementId = 4,
    /** matches using the id directly against the single historically tagged named element */
    withHistoricalElementId = 11,
    /** matches using the id directly against the single historically tagged named element */
    withoutHistoricalElementId = 14,
    /** matches events that were tagged historically with a named element id */
    withSetHistoricalElementId = 12,
    /** matches events that were not tagged historically with a named element id */
    withUnsetHistoricalElementId = 13,
    textContainsToken = 5,
    textStartsWith = 6,
    textEndsWith = 7,
    textIsNot = 8,
    textNotContainsToken = 9,
    textContainsTokenStartsWith = 10
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    any = 'any',
    text = 'text',
    css = 'css',
    cssIsNot = 'cssIsNot',
    /** matches the full canonicalized css string value exactly */
    exactCss = 'exactCss',
    cssSubstring = 'cssSubstring',
    /** matches retroactively using the current named element definition */
    withElementId = 'withElementId',
    /** matches using the id directly against the single historically tagged named element */
    withHistoricalElementId = 'withHistoricalElementId',
    /** matches using the id directly against the single historically tagged named element */
    withoutHistoricalElementId = 'withoutHistoricalElementId',
    /** matches events that were tagged historically with a named element id */
    withSetHistoricalElementId = 'withSetHistoricalElementId',
    /** matches events that were not tagged historically with a named element id */
    withUnsetHistoricalElementId = 'withUnsetHistoricalElementId',
    textContainsToken = 'textContainsToken',
    textStartsWith = 'textStartsWith',
    textEndsWith = 'textEndsWith',
    textIsNot = 'textIsNot',
    textNotContainsToken = 'textNotContainsToken',
    textContainsTokenStartsWith = 'textContainsTokenStartsWith'
  }

  export function operator_oneof(m: ElementOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.css, key: operator_keys.css, val: RepeatedStringValue } | { opt: operator.cssIsNot, key: operator_keys.cssIsNot, val: RepeatedStringValue } | { opt: operator.cssSubstring, key: operator_keys.cssSubstring, val: RepeatedStringValue } | { opt: operator.exactCss, key: operator_keys.exactCss, val: RepeatedStringValue } | { opt: operator.text, key: operator_keys.text, val: RepeatedStringValue } | { opt: operator.textContainsToken, key: operator_keys.textContainsToken, val: RepeatedStringValue } | { opt: operator.textContainsTokenStartsWith, key: operator_keys.textContainsTokenStartsWith, val: RepeatedStringValue } | { opt: operator.textEndsWith, key: operator_keys.textEndsWith, val: RepeatedStringValue } | { opt: operator.textIsNot, key: operator_keys.textIsNot, val: RepeatedStringValue } | { opt: operator.textNotContainsToken, key: operator_keys.textNotContainsToken, val: RepeatedStringValue } | { opt: operator.textStartsWith, key: operator_keys.textStartsWith, val: RepeatedStringValue } | { opt: operator.withElementId, key: operator_keys.withElementId, val: RepeatedNamedElementValue } | { opt: operator.withHistoricalElementId, key: operator_keys.withHistoricalElementId, val: RepeatedNamedElementValue } | { opt: operator.withSetHistoricalElementId, key: operator_keys.withSetHistoricalElementId, val: NoneValue } | { opt: operator.withUnsetHistoricalElementId, key: operator_keys.withUnsetHistoricalElementId, val: NoneValue } | { opt: operator.withoutHistoricalElementId, key: operator_keys.withoutHistoricalElementId, val: RepeatedNamedElementValue } | null {
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    if (m.text != null) { return { opt: operator.text, key: operator_keys.text, val: m.text } }
    if (m.css != null) { return { opt: operator.css, key: operator_keys.css, val: m.css } }
    if (m.cssIsNot != null) { return { opt: operator.cssIsNot, key: operator_keys.cssIsNot, val: m.cssIsNot } }
    if (m.exactCss != null) { return { opt: operator.exactCss, key: operator_keys.exactCss, val: m.exactCss } }
    if (m.cssSubstring != null) { return { opt: operator.cssSubstring, key: operator_keys.cssSubstring, val: m.cssSubstring } }
    if (m.withElementId != null) { return { opt: operator.withElementId, key: operator_keys.withElementId, val: m.withElementId } }
    if (m.withHistoricalElementId != null) { return { opt: operator.withHistoricalElementId, key: operator_keys.withHistoricalElementId, val: m.withHistoricalElementId } }
    if (m.withoutHistoricalElementId != null) { return { opt: operator.withoutHistoricalElementId, key: operator_keys.withoutHistoricalElementId, val: m.withoutHistoricalElementId } }
    if (m.withSetHistoricalElementId != null) { return { opt: operator.withSetHistoricalElementId, key: operator_keys.withSetHistoricalElementId, val: m.withSetHistoricalElementId } }
    if (m.withUnsetHistoricalElementId != null) { return { opt: operator.withUnsetHistoricalElementId, key: operator_keys.withUnsetHistoricalElementId, val: m.withUnsetHistoricalElementId } }
    if (m.textContainsToken != null) { return { opt: operator.textContainsToken, key: operator_keys.textContainsToken, val: m.textContainsToken } }
    if (m.textStartsWith != null) { return { opt: operator.textStartsWith, key: operator_keys.textStartsWith, val: m.textStartsWith } }
    if (m.textEndsWith != null) { return { opt: operator.textEndsWith, key: operator_keys.textEndsWith, val: m.textEndsWith } }
    if (m.textIsNot != null) { return { opt: operator.textIsNot, key: operator_keys.textIsNot, val: m.textIsNot } }
    if (m.textNotContainsToken != null) { return { opt: operator.textNotContainsToken, key: operator_keys.textNotContainsToken, val: m.textNotContainsToken } }
    if (m.textContainsTokenStartsWith != null) { return { opt: operator.textContainsTokenStartsWith, key: operator_keys.textContainsTokenStartsWith, val: m.textContainsTokenStartsWith } }
    return null;
  }
}

export interface UrlOperator {
  equals?: UrlValue | null;
  notEquals?: UrlValue | null;
  startsWith?: UrlValue | null;
  endsWith?: UrlValue | null;
  containsToken?: UrlValue | null;
  notContainsToken?: UrlValue | null;
  containsTokenStartsWith?: UrlValue | null;
  /** UrlValue contains_token_ends_with = 8; */
  substring?: UrlValue | null;
  any?: NoneValue | null;
  isSet?: NoneValue | null;
  isUnset?: NoneValue | null;
  /** Really only for URL path presently */
  matches?: UrlValue | null;
  notMatches?: UrlValue | null;
}

export namespace UrlOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    startsWith = 3,
    endsWith = 4,
    containsToken = 5,
    notContainsToken = 6,
    containsTokenStartsWith = 7,
    /** UrlValue contains_token_ends_with = 8; */
    substring = 9,
    any = 10,
    isSet = 13,
    isUnset = 14,
    /** Really only for URL path presently */
    matches = 11,
    notMatches = 12
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    containsToken = 'containsToken',
    notContainsToken = 'notContainsToken',
    containsTokenStartsWith = 'containsTokenStartsWith',
    /** UrlValue contains_token_ends_with = 8; */
    substring = 'substring',
    any = 'any',
    isSet = 'isSet',
    isUnset = 'isUnset',
    /** Really only for URL path presently */
    matches = 'matches',
    notMatches = 'notMatches'
  }

  export function operator_oneof(m: UrlOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.containsToken, key: operator_keys.containsToken, val: UrlValue } | { opt: operator.containsTokenStartsWith, key: operator_keys.containsTokenStartsWith, val: UrlValue } | { opt: operator.endsWith, key: operator_keys.endsWith, val: UrlValue } | { opt: operator.equals, key: operator_keys.equals, val: UrlValue } | { opt: operator.isSet, key: operator_keys.isSet, val: NoneValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: NoneValue } | { opt: operator.matches, key: operator_keys.matches, val: UrlValue } | { opt: operator.notContainsToken, key: operator_keys.notContainsToken, val: UrlValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: UrlValue } | { opt: operator.notMatches, key: operator_keys.notMatches, val: UrlValue } | { opt: operator.startsWith, key: operator_keys.startsWith, val: UrlValue } | { opt: operator.substring, key: operator_keys.substring, val: UrlValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.startsWith != null) { return { opt: operator.startsWith, key: operator_keys.startsWith, val: m.startsWith } }
    if (m.endsWith != null) { return { opt: operator.endsWith, key: operator_keys.endsWith, val: m.endsWith } }
    if (m.containsToken != null) { return { opt: operator.containsToken, key: operator_keys.containsToken, val: m.containsToken } }
    if (m.notContainsToken != null) { return { opt: operator.notContainsToken, key: operator_keys.notContainsToken, val: m.notContainsToken } }
    if (m.containsTokenStartsWith != null) { return { opt: operator.containsTokenStartsWith, key: operator_keys.containsTokenStartsWith, val: m.containsTokenStartsWith } }
    if (m.substring != null) { return { opt: operator.substring, key: operator_keys.substring, val: m.substring } }
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    if (m.matches != null) { return { opt: operator.matches, key: operator_keys.matches, val: m.matches } }
    if (m.notMatches != null) { return { opt: operator.notMatches, key: operator_keys.notMatches, val: m.notMatches } }
    return null;
  }
}

export interface DurationOperator {
  atLeast?: DurationValue | null;
  atMost?: DurationValue | null;
  lessThan?: DurationValue | null;
  greaterThan?: DurationValue | null;
  range?: DurationRangeValue | null;
  notRange?: DurationRangeValue | null;
}

export namespace DurationOperator {
  export enum operator {
    atLeast = 1,
    atMost = 2,
    lessThan = 3,
    greaterThan = 4,
    range = 5,
    notRange = 6
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    atLeast = 'atLeast',
    atMost = 'atMost',
    lessThan = 'lessThan',
    greaterThan = 'greaterThan',
    range = 'range',
    notRange = 'notRange'
  }

  export function operator_oneof(m: DurationOperator): { opt: operator.atLeast, key: operator_keys.atLeast, val: DurationValue } | { opt: operator.atMost, key: operator_keys.atMost, val: DurationValue } | { opt: operator.greaterThan, key: operator_keys.greaterThan, val: DurationValue } | { opt: operator.lessThan, key: operator_keys.lessThan, val: DurationValue } | { opt: operator.notRange, key: operator_keys.notRange, val: DurationRangeValue } | { opt: operator.range, key: operator_keys.range, val: DurationRangeValue } | null {
    if (m.atLeast != null) { return { opt: operator.atLeast, key: operator_keys.atLeast, val: m.atLeast } }
    if (m.atMost != null) { return { opt: operator.atMost, key: operator_keys.atMost, val: m.atMost } }
    if (m.lessThan != null) { return { opt: operator.lessThan, key: operator_keys.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, key: operator_keys.greaterThan, val: m.greaterThan } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    return null;
  }
}

export interface AbandonedOperator {
  any?: NoneValue | null;
  css?: RepeatedStringValue | null;
  cssIsNot?: RepeatedStringValue | null;
  /** matches the full canonicalized css string value exactly */
  exactCss?: RepeatedStringValue | null;
  /** matches retroactively using the current named element definition */
  withElementId?: RepeatedNamedElementValue | null;
  /** matches using the id directly against the single historically tagged named element */
  withHistoricalElementId?: RepeatedNamedElementValue | null;
  /** matches using the id directly against the single historically tagged named element */
  withoutHistoricalElementId?: RepeatedNamedElementValue | null;
  /** matches events that were tagged historically with a named element id */
  withSetHistoricalElementId?: NoneValue | null;
  /** matches events that were not tagged historically with a named element id */
  withUnsetHistoricalElementId?: NoneValue | null;
}

export namespace AbandonedOperator {
  export enum operator {
    any = 1,
    css = 3,
    cssIsNot = 10,
    /** matches the full canonicalized css string value exactly */
    exactCss = 9,
    /** matches retroactively using the current named element definition */
    withElementId = 4,
    /** matches using the id directly against the single historically tagged named element */
    withHistoricalElementId = 5,
    /** matches using the id directly against the single historically tagged named element */
    withoutHistoricalElementId = 8,
    /** matches events that were tagged historically with a named element id */
    withSetHistoricalElementId = 6,
    /** matches events that were not tagged historically with a named element id */
    withUnsetHistoricalElementId = 7
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    any = 'any',
    css = 'css',
    cssIsNot = 'cssIsNot',
    /** matches the full canonicalized css string value exactly */
    exactCss = 'exactCss',
    /** matches retroactively using the current named element definition */
    withElementId = 'withElementId',
    /** matches using the id directly against the single historically tagged named element */
    withHistoricalElementId = 'withHistoricalElementId',
    /** matches using the id directly against the single historically tagged named element */
    withoutHistoricalElementId = 'withoutHistoricalElementId',
    /** matches events that were tagged historically with a named element id */
    withSetHistoricalElementId = 'withSetHistoricalElementId',
    /** matches events that were not tagged historically with a named element id */
    withUnsetHistoricalElementId = 'withUnsetHistoricalElementId'
  }

  export function operator_oneof(m: AbandonedOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.css, key: operator_keys.css, val: RepeatedStringValue } | { opt: operator.cssIsNot, key: operator_keys.cssIsNot, val: RepeatedStringValue } | { opt: operator.exactCss, key: operator_keys.exactCss, val: RepeatedStringValue } | { opt: operator.withElementId, key: operator_keys.withElementId, val: RepeatedNamedElementValue } | { opt: operator.withHistoricalElementId, key: operator_keys.withHistoricalElementId, val: RepeatedNamedElementValue } | { opt: operator.withSetHistoricalElementId, key: operator_keys.withSetHistoricalElementId, val: NoneValue } | { opt: operator.withUnsetHistoricalElementId, key: operator_keys.withUnsetHistoricalElementId, val: NoneValue } | { opt: operator.withoutHistoricalElementId, key: operator_keys.withoutHistoricalElementId, val: RepeatedNamedElementValue } | null {
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    if (m.css != null) { return { opt: operator.css, key: operator_keys.css, val: m.css } }
    if (m.cssIsNot != null) { return { opt: operator.cssIsNot, key: operator_keys.cssIsNot, val: m.cssIsNot } }
    if (m.exactCss != null) { return { opt: operator.exactCss, key: operator_keys.exactCss, val: m.exactCss } }
    if (m.withElementId != null) { return { opt: operator.withElementId, key: operator_keys.withElementId, val: m.withElementId } }
    if (m.withHistoricalElementId != null) { return { opt: operator.withHistoricalElementId, key: operator_keys.withHistoricalElementId, val: m.withHistoricalElementId } }
    if (m.withoutHistoricalElementId != null) { return { opt: operator.withoutHistoricalElementId, key: operator_keys.withoutHistoricalElementId, val: m.withoutHistoricalElementId } }
    if (m.withSetHistoricalElementId != null) { return { opt: operator.withSetHistoricalElementId, key: operator_keys.withSetHistoricalElementId, val: m.withSetHistoricalElementId } }
    if (m.withUnsetHistoricalElementId != null) { return { opt: operator.withUnsetHistoricalElementId, key: operator_keys.withUnsetHistoricalElementId, val: m.withUnsetHistoricalElementId } }
    return null;
  }
}

export interface StringOperator {
  equals?: RepeatedStringValue | null;
  notEquals?: RepeatedStringValue | null;
  startsWith?: RepeatedStringValue | null;
  endsWith?: RepeatedStringValue | null;
  containsToken?: RepeatedStringValue | null;
  notContainsToken?: RepeatedStringValue | null;
  containsTokenStartsWith?: RepeatedStringValue | null;
  /** RepeatedStringValue contains_token_ends_with = 8; */
  substring?: RepeatedStringValue | null;
  any?: NoneValue | null;
}

export namespace StringOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    startsWith = 3,
    endsWith = 4,
    containsToken = 5,
    notContainsToken = 6,
    containsTokenStartsWith = 7,
    /** RepeatedStringValue contains_token_ends_with = 8; */
    substring = 9,
    any = 10
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    containsToken = 'containsToken',
    notContainsToken = 'notContainsToken',
    containsTokenStartsWith = 'containsTokenStartsWith',
    /** RepeatedStringValue contains_token_ends_with = 8; */
    substring = 'substring',
    any = 'any'
  }

  export function operator_oneof(m: StringOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.containsToken, key: operator_keys.containsToken, val: RepeatedStringValue } | { opt: operator.containsTokenStartsWith, key: operator_keys.containsTokenStartsWith, val: RepeatedStringValue } | { opt: operator.endsWith, key: operator_keys.endsWith, val: RepeatedStringValue } | { opt: operator.equals, key: operator_keys.equals, val: RepeatedStringValue } | { opt: operator.notContainsToken, key: operator_keys.notContainsToken, val: RepeatedStringValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: RepeatedStringValue } | { opt: operator.startsWith, key: operator_keys.startsWith, val: RepeatedStringValue } | { opt: operator.substring, key: operator_keys.substring, val: RepeatedStringValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.startsWith != null) { return { opt: operator.startsWith, key: operator_keys.startsWith, val: m.startsWith } }
    if (m.endsWith != null) { return { opt: operator.endsWith, key: operator_keys.endsWith, val: m.endsWith } }
    if (m.containsToken != null) { return { opt: operator.containsToken, key: operator_keys.containsToken, val: m.containsToken } }
    if (m.notContainsToken != null) { return { opt: operator.notContainsToken, key: operator_keys.notContainsToken, val: m.notContainsToken } }
    if (m.containsTokenStartsWith != null) { return { opt: operator.containsTokenStartsWith, key: operator_keys.containsTokenStartsWith, val: m.containsTokenStartsWith } }
    if (m.substring != null) { return { opt: operator.substring, key: operator_keys.substring, val: m.substring } }
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    return null;
  }
}

export interface CustomEventOperator {
  any?: NoneValue | null;
  named?: NamedCustomEventValue | null;
  notNamed?: RepeatedStringValue | null;
}

export namespace CustomEventOperator {
  export enum operator {
    any = 1,
    named = 2,
    notNamed = 3
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    any = 'any',
    named = 'named',
    notNamed = 'notNamed'
  }

  export function operator_oneof(m: CustomEventOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.named, key: operator_keys.named, val: NamedCustomEventValue } | { opt: operator.notNamed, key: operator_keys.notNamed, val: RepeatedStringValue } | null {
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    if (m.named != null) { return { opt: operator.named, key: operator_keys.named, val: m.named } }
    if (m.notNamed != null) { return { opt: operator.notNamed, key: operator_keys.notNamed, val: m.notNamed } }
    return null;
  }
}

export interface ApiErrorOperator {
  any?: NoneValue | null;
  unknown?: NoneValue | null;
  missingType?: NoneValue | null;
  invalidName?: NoneValue | null;
  immutable?: NoneValue | null;
  invalidId?: NoneValue | null;
  nameLength?: NoneValue | null;
  valueLength?: NoneValue | null;
  parse?: NoneValue | null;
  atom?: NoneValue | null;
  invalidType?: NoneValue | null;
  invalidValue?: NoneValue | null;
  rateLimit?: NoneValue | null;
  invalidEventName?: NoneValue | null;
  nameCardinalityLimit?: NoneValue | null;
  propertyCardinalityLimit?: NoneValue | null;
  userVarCardinalityLimit?: NoneValue | null;
  invalidJson?: NoneValue | null;
  pageVarCardinalityLimit?: NoneValue | null;
  pageVarPerPageLimit?: NoneValue | null;
  pageVarNameChanged?: NoneValue | null;
  elemVarCardinalityLimit?: NoneValue | null;
  elemVarPerEventLimit?: NoneValue | null;
  apiElemCardinalityLimit?: NoneValue | null;
}

export namespace ApiErrorOperator {
  export enum operator {
    any = 1,
    unknown = 2,
    missingType = 3,
    invalidName = 4,
    immutable = 5,
    invalidId = 6,
    nameLength = 7,
    valueLength = 8,
    parse = 9,
    atom = 10,
    invalidType = 11,
    invalidValue = 12,
    rateLimit = 13,
    invalidEventName = 14,
    nameCardinalityLimit = 15,
    propertyCardinalityLimit = 16,
    userVarCardinalityLimit = 17,
    invalidJson = 18,
    pageVarCardinalityLimit = 19,
    pageVarPerPageLimit = 20,
    pageVarNameChanged = 21,
    elemVarCardinalityLimit = 22,
    elemVarPerEventLimit = 23,
    apiElemCardinalityLimit = 24
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    any = 'any',
    unknown = 'unknown',
    missingType = 'missingType',
    invalidName = 'invalidName',
    immutable = 'immutable',
    invalidId = 'invalidId',
    nameLength = 'nameLength',
    valueLength = 'valueLength',
    parse = 'parse',
    atom = 'atom',
    invalidType = 'invalidType',
    invalidValue = 'invalidValue',
    rateLimit = 'rateLimit',
    invalidEventName = 'invalidEventName',
    nameCardinalityLimit = 'nameCardinalityLimit',
    propertyCardinalityLimit = 'propertyCardinalityLimit',
    userVarCardinalityLimit = 'userVarCardinalityLimit',
    invalidJson = 'invalidJson',
    pageVarCardinalityLimit = 'pageVarCardinalityLimit',
    pageVarPerPageLimit = 'pageVarPerPageLimit',
    pageVarNameChanged = 'pageVarNameChanged',
    elemVarCardinalityLimit = 'elemVarCardinalityLimit',
    elemVarPerEventLimit = 'elemVarPerEventLimit',
    apiElemCardinalityLimit = 'apiElemCardinalityLimit'
  }

  export function operator_oneof(m: ApiErrorOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.apiElemCardinalityLimit, key: operator_keys.apiElemCardinalityLimit, val: NoneValue } | { opt: operator.atom, key: operator_keys.atom, val: NoneValue } | { opt: operator.elemVarCardinalityLimit, key: operator_keys.elemVarCardinalityLimit, val: NoneValue } | { opt: operator.elemVarPerEventLimit, key: operator_keys.elemVarPerEventLimit, val: NoneValue } | { opt: operator.immutable, key: operator_keys.immutable, val: NoneValue } | { opt: operator.invalidEventName, key: operator_keys.invalidEventName, val: NoneValue } | { opt: operator.invalidId, key: operator_keys.invalidId, val: NoneValue } | { opt: operator.invalidJson, key: operator_keys.invalidJson, val: NoneValue } | { opt: operator.invalidName, key: operator_keys.invalidName, val: NoneValue } | { opt: operator.invalidType, key: operator_keys.invalidType, val: NoneValue } | { opt: operator.invalidValue, key: operator_keys.invalidValue, val: NoneValue } | { opt: operator.missingType, key: operator_keys.missingType, val: NoneValue } | { opt: operator.nameCardinalityLimit, key: operator_keys.nameCardinalityLimit, val: NoneValue } | { opt: operator.nameLength, key: operator_keys.nameLength, val: NoneValue } | { opt: operator.pageVarCardinalityLimit, key: operator_keys.pageVarCardinalityLimit, val: NoneValue } | { opt: operator.pageVarNameChanged, key: operator_keys.pageVarNameChanged, val: NoneValue } | { opt: operator.pageVarPerPageLimit, key: operator_keys.pageVarPerPageLimit, val: NoneValue } | { opt: operator.parse, key: operator_keys.parse, val: NoneValue } | { opt: operator.propertyCardinalityLimit, key: operator_keys.propertyCardinalityLimit, val: NoneValue } | { opt: operator.rateLimit, key: operator_keys.rateLimit, val: NoneValue } | { opt: operator.unknown, key: operator_keys.unknown, val: NoneValue } | { opt: operator.userVarCardinalityLimit, key: operator_keys.userVarCardinalityLimit, val: NoneValue } | { opt: operator.valueLength, key: operator_keys.valueLength, val: NoneValue } | null {
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    if (m.unknown != null) { return { opt: operator.unknown, key: operator_keys.unknown, val: m.unknown } }
    if (m.missingType != null) { return { opt: operator.missingType, key: operator_keys.missingType, val: m.missingType } }
    if (m.invalidName != null) { return { opt: operator.invalidName, key: operator_keys.invalidName, val: m.invalidName } }
    if (m.immutable != null) { return { opt: operator.immutable, key: operator_keys.immutable, val: m.immutable } }
    if (m.invalidId != null) { return { opt: operator.invalidId, key: operator_keys.invalidId, val: m.invalidId } }
    if (m.nameLength != null) { return { opt: operator.nameLength, key: operator_keys.nameLength, val: m.nameLength } }
    if (m.valueLength != null) { return { opt: operator.valueLength, key: operator_keys.valueLength, val: m.valueLength } }
    if (m.parse != null) { return { opt: operator.parse, key: operator_keys.parse, val: m.parse } }
    if (m.atom != null) { return { opt: operator.atom, key: operator_keys.atom, val: m.atom } }
    if (m.invalidType != null) { return { opt: operator.invalidType, key: operator_keys.invalidType, val: m.invalidType } }
    if (m.invalidValue != null) { return { opt: operator.invalidValue, key: operator_keys.invalidValue, val: m.invalidValue } }
    if (m.rateLimit != null) { return { opt: operator.rateLimit, key: operator_keys.rateLimit, val: m.rateLimit } }
    if (m.invalidEventName != null) { return { opt: operator.invalidEventName, key: operator_keys.invalidEventName, val: m.invalidEventName } }
    if (m.nameCardinalityLimit != null) { return { opt: operator.nameCardinalityLimit, key: operator_keys.nameCardinalityLimit, val: m.nameCardinalityLimit } }
    if (m.propertyCardinalityLimit != null) { return { opt: operator.propertyCardinalityLimit, key: operator_keys.propertyCardinalityLimit, val: m.propertyCardinalityLimit } }
    if (m.userVarCardinalityLimit != null) { return { opt: operator.userVarCardinalityLimit, key: operator_keys.userVarCardinalityLimit, val: m.userVarCardinalityLimit } }
    if (m.invalidJson != null) { return { opt: operator.invalidJson, key: operator_keys.invalidJson, val: m.invalidJson } }
    if (m.pageVarCardinalityLimit != null) { return { opt: operator.pageVarCardinalityLimit, key: operator_keys.pageVarCardinalityLimit, val: m.pageVarCardinalityLimit } }
    if (m.pageVarPerPageLimit != null) { return { opt: operator.pageVarPerPageLimit, key: operator_keys.pageVarPerPageLimit, val: m.pageVarPerPageLimit } }
    if (m.pageVarNameChanged != null) { return { opt: operator.pageVarNameChanged, key: operator_keys.pageVarNameChanged, val: m.pageVarNameChanged } }
    if (m.elemVarCardinalityLimit != null) { return { opt: operator.elemVarCardinalityLimit, key: operator_keys.elemVarCardinalityLimit, val: m.elemVarCardinalityLimit } }
    if (m.elemVarPerEventLimit != null) { return { opt: operator.elemVarPerEventLimit, key: operator_keys.elemVarPerEventLimit, val: m.elemVarPerEventLimit } }
    if (m.apiElemCardinalityLimit != null) { return { opt: operator.apiElemCardinalityLimit, key: operator_keys.apiElemCardinalityLimit, val: m.apiElemCardinalityLimit } }
    return null;
  }
}

export interface BrowserOperator {
  equals?: BrowserValue | null;
  notEquals?: BrowserValue | null;
}

export namespace BrowserOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: BrowserOperator): { opt: operator.equals, key: operator_keys.equals, val: BrowserValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: BrowserValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface DeviceOperator {
  equals?: DeviceValue | null;
  notEquals?: DeviceValue | null;
}

export namespace DeviceOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: DeviceOperator): { opt: operator.equals, key: operator_keys.equals, val: DeviceValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: DeviceValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface PlatformOperator {
  equals?: PlatformValue | null;
  notEquals?: PlatformValue | null;
}

export namespace PlatformOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: PlatformOperator): { opt: operator.equals, key: operator_keys.equals, val: PlatformValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: PlatformValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface NativePlatformOperator {
  equals?: NativePlatformValue | null;
}

export namespace NativePlatformOperator {
  export enum operator {
    equals = 1
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals'
  }

  export function operator_oneof(m: NativePlatformOperator): { opt: operator.equals, key: operator_keys.equals, val: NativePlatformValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    return null;
  }
}

export interface OSOperator {
  equals?: OSValue | null;
  notEquals?: OSValue | null;
}

export namespace OSOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: OSOperator): { opt: operator.equals, key: operator_keys.equals, val: OSValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: OSValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface SessionTypeOperator {
  equals?: SessionTypeValue | null;
  notEquals?: SessionTypeValue | null;
}

export namespace SessionTypeOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: SessionTypeOperator): { opt: operator.equals, key: operator_keys.equals, val: SessionTypeValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: SessionTypeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface StringRangeOperator {
  equals?: RepeatedStringValue | null;
  notEquals?: RepeatedStringValue | null;
  startsWith?: RepeatedStringValue | null;
  endsWith?: RepeatedStringValue | null;
  lessThan?: StringValue | null;
  greaterThan?: StringValue | null;
  atMost?: StringValue | null;
  atLeast?: StringValue | null;
}

export namespace StringRangeOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    startsWith = 3,
    endsWith = 4,
    lessThan = 5,
    greaterThan = 6,
    atMost = 7,
    atLeast = 8
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    lessThan = 'lessThan',
    greaterThan = 'greaterThan',
    atMost = 'atMost',
    atLeast = 'atLeast'
  }

  export function operator_oneof(m: StringRangeOperator): { opt: operator.atLeast, key: operator_keys.atLeast, val: StringValue } | { opt: operator.atMost, key: operator_keys.atMost, val: StringValue } | { opt: operator.endsWith, key: operator_keys.endsWith, val: RepeatedStringValue } | { opt: operator.equals, key: operator_keys.equals, val: RepeatedStringValue } | { opt: operator.greaterThan, key: operator_keys.greaterThan, val: StringValue } | { opt: operator.lessThan, key: operator_keys.lessThan, val: StringValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: RepeatedStringValue } | { opt: operator.startsWith, key: operator_keys.startsWith, val: RepeatedStringValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.startsWith != null) { return { opt: operator.startsWith, key: operator_keys.startsWith, val: m.startsWith } }
    if (m.endsWith != null) { return { opt: operator.endsWith, key: operator_keys.endsWith, val: m.endsWith } }
    if (m.lessThan != null) { return { opt: operator.lessThan, key: operator_keys.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, key: operator_keys.greaterThan, val: m.greaterThan } }
    if (m.atMost != null) { return { opt: operator.atMost, key: operator_keys.atMost, val: m.atMost } }
    if (m.atLeast != null) { return { opt: operator.atLeast, key: operator_keys.atLeast, val: m.atLeast } }
    return null;
  }
}

export interface NumericIdOperator {
  equals?: RepeatedNumericValue | null;
  notEquals?: RepeatedNumericValue | null;
  any?: NoneValue | null;
}

export namespace NumericIdOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    any = 3
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    any = 'any'
  }

  export function operator_oneof(m: NumericIdOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.equals, key: operator_keys.equals, val: RepeatedNumericValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: RepeatedNumericValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    return null;
  }
}

export interface PageRefOperator {
  equals?: RepeatedPageRefValue | null;
  notEquals?: RepeatedPageRefValue | null;
  any?: NoneValue | null;
}

export namespace PageRefOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    any = 3
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    any = 'any'
  }

  export function operator_oneof(m: PageRefOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.equals, key: operator_keys.equals, val: RepeatedPageRefValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: RepeatedPageRefValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    return null;
  }
}

export interface NumericOperator {
  equals?: RepeatedNumericValue | null;
  notEquals?: RepeatedNumericValue | null;
  lessThan?: NumericValue | null;
  greaterThan?: NumericValue | null;
  atMost?: NumericValue | null;
  atLeast?: NumericValue | null;
  range?: NumericRangeValue | null;
  notRange?: NumericRangeValue | null;
}

export namespace NumericOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    lessThan = 3,
    greaterThan = 4,
    atMost = 5,
    atLeast = 6,
    range = 7,
    notRange = 8
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    lessThan = 'lessThan',
    greaterThan = 'greaterThan',
    atMost = 'atMost',
    atLeast = 'atLeast',
    range = 'range',
    notRange = 'notRange'
  }

  export function operator_oneof(m: NumericOperator): { opt: operator.atLeast, key: operator_keys.atLeast, val: NumericValue } | { opt: operator.atMost, key: operator_keys.atMost, val: NumericValue } | { opt: operator.equals, key: operator_keys.equals, val: RepeatedNumericValue } | { opt: operator.greaterThan, key: operator_keys.greaterThan, val: NumericValue } | { opt: operator.lessThan, key: operator_keys.lessThan, val: NumericValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: RepeatedNumericValue } | { opt: operator.notRange, key: operator_keys.notRange, val: NumericRangeValue } | { opt: operator.range, key: operator_keys.range, val: NumericRangeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.lessThan != null) { return { opt: operator.lessThan, key: operator_keys.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, key: operator_keys.greaterThan, val: m.greaterThan } }
    if (m.atMost != null) { return { opt: operator.atMost, key: operator_keys.atMost, val: m.atMost } }
    if (m.atLeast != null) { return { opt: operator.atLeast, key: operator_keys.atLeast, val: m.atLeast } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    return null;
  }
}

export interface FloatOperator {
  equals?: RepeatedFloatValue | null;
  notEquals?: RepeatedFloatValue | null;
  lessThan?: FloatValue | null;
  greaterThan?: FloatValue | null;
  atMost?: FloatValue | null;
  atLeast?: FloatValue | null;
  range?: FloatRangeValue | null;
  notRange?: FloatRangeValue | null;
}

export namespace FloatOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    lessThan = 3,
    greaterThan = 4,
    atMost = 5,
    atLeast = 6,
    range = 7,
    notRange = 8
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    lessThan = 'lessThan',
    greaterThan = 'greaterThan',
    atMost = 'atMost',
    atLeast = 'atLeast',
    range = 'range',
    notRange = 'notRange'
  }

  export function operator_oneof(m: FloatOperator): { opt: operator.atLeast, key: operator_keys.atLeast, val: FloatValue } | { opt: operator.atMost, key: operator_keys.atMost, val: FloatValue } | { opt: operator.equals, key: operator_keys.equals, val: RepeatedFloatValue } | { opt: operator.greaterThan, key: operator_keys.greaterThan, val: FloatValue } | { opt: operator.lessThan, key: operator_keys.lessThan, val: FloatValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: RepeatedFloatValue } | { opt: operator.notRange, key: operator_keys.notRange, val: FloatRangeValue } | { opt: operator.range, key: operator_keys.range, val: FloatRangeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.lessThan != null) { return { opt: operator.lessThan, key: operator_keys.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, key: operator_keys.greaterThan, val: m.greaterThan } }
    if (m.atMost != null) { return { opt: operator.atMost, key: operator_keys.atMost, val: m.atMost } }
    if (m.atLeast != null) { return { opt: operator.atLeast, key: operator_keys.atLeast, val: m.atLeast } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    return null;
  }
}

export interface TextOperator {
  equals?: RepeatedStringValue | null;
  containsToken?: RepeatedStringValue | null;
  startsWith?: RepeatedStringValue | null;
  endsWith?: RepeatedStringValue | null;
  notEquals?: RepeatedStringValue | null;
  notContainsToken?: RepeatedStringValue | null;
  containsTokenStartsWith?: RepeatedStringValue | null;
}

export namespace TextOperator {
  export enum operator {
    equals = 1,
    containsToken = 2,
    startsWith = 3,
    endsWith = 4,
    notEquals = 5,
    notContainsToken = 6,
    containsTokenStartsWith = 7
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    containsToken = 'containsToken',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    notEquals = 'notEquals',
    notContainsToken = 'notContainsToken',
    containsTokenStartsWith = 'containsTokenStartsWith'
  }

  export function operator_oneof(m: TextOperator): { opt: operator.containsToken, key: operator_keys.containsToken, val: RepeatedStringValue } | { opt: operator.containsTokenStartsWith, key: operator_keys.containsTokenStartsWith, val: RepeatedStringValue } | { opt: operator.endsWith, key: operator_keys.endsWith, val: RepeatedStringValue } | { opt: operator.equals, key: operator_keys.equals, val: RepeatedStringValue } | { opt: operator.notContainsToken, key: operator_keys.notContainsToken, val: RepeatedStringValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: RepeatedStringValue } | { opt: operator.startsWith, key: operator_keys.startsWith, val: RepeatedStringValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.containsToken != null) { return { opt: operator.containsToken, key: operator_keys.containsToken, val: m.containsToken } }
    if (m.startsWith != null) { return { opt: operator.startsWith, key: operator_keys.startsWith, val: m.startsWith } }
    if (m.endsWith != null) { return { opt: operator.endsWith, key: operator_keys.endsWith, val: m.endsWith } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.notContainsToken != null) { return { opt: operator.notContainsToken, key: operator_keys.notContainsToken, val: m.notContainsToken } }
    if (m.containsTokenStartsWith != null) { return { opt: operator.containsTokenStartsWith, key: operator_keys.containsTokenStartsWith, val: m.containsTokenStartsWith } }
    return null;
  }
}

export interface CssOperator {
  matches?: RepeatedStringValue | null;
  notMatches?: RepeatedStringValue | null;
  /** matches the full canonicalized css string value exactly */
  exact?: RepeatedStringValue | null;
  /** does not exactly match the full canonicalized css string value */
  notExact?: RepeatedStringValue | null;
}

export namespace CssOperator {
  export enum operator {
    matches = 1,
    notMatches = 3,
    /** matches the full canonicalized css string value exactly */
    exact = 2,
    /** does not exactly match the full canonicalized css string value */
    notExact = 4
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    matches = 'matches',
    notMatches = 'notMatches',
    /** matches the full canonicalized css string value exactly */
    exact = 'exact',
    /** does not exactly match the full canonicalized css string value */
    notExact = 'notExact'
  }

  export function operator_oneof(m: CssOperator): { opt: operator.exact, key: operator_keys.exact, val: RepeatedStringValue } | { opt: operator.matches, key: operator_keys.matches, val: RepeatedStringValue } | { opt: operator.notExact, key: operator_keys.notExact, val: RepeatedStringValue } | { opt: operator.notMatches, key: operator_keys.notMatches, val: RepeatedStringValue } | null {
    if (m.matches != null) { return { opt: operator.matches, key: operator_keys.matches, val: m.matches } }
    if (m.notMatches != null) { return { opt: operator.notMatches, key: operator_keys.notMatches, val: m.notMatches } }
    if (m.exact != null) { return { opt: operator.exact, key: operator_keys.exact, val: m.exact } }
    if (m.notExact != null) { return { opt: operator.notExact, key: operator_keys.notExact, val: m.notExact } }
    return null;
  }
}

export interface ElementIdOperator {
  /** matches retroactively using the current named element definition */
  withElementId?: RepeatedNamedElementValue | null;
  /** matches using the id directly against the single historically tagged named element */
  withHistoricalElementId?: RepeatedNamedElementValue | null;
  /** matches using the id directly against the single historically tagged named element */
  withoutHistoricalElementId?: RepeatedNamedElementValue | null;
  /** matches events that were tagged historically with a named element id */
  withSetHistoricalElementId?: NoneValue | null;
  /** matches events that were not tagged historically with a named element id */
  withUnsetHistoricalElementId?: NoneValue | null;
}

export namespace ElementIdOperator {
  export enum operator {
    /** matches retroactively using the current named element definition */
    withElementId = 1,
    /** matches using the id directly against the single historically tagged named element */
    withHistoricalElementId = 2,
    /** matches using the id directly against the single historically tagged named element */
    withoutHistoricalElementId = 5,
    /** matches events that were tagged historically with a named element id */
    withSetHistoricalElementId = 3,
    /** matches events that were not tagged historically with a named element id */
    withUnsetHistoricalElementId = 4
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    /** matches retroactively using the current named element definition */
    withElementId = 'withElementId',
    /** matches using the id directly against the single historically tagged named element */
    withHistoricalElementId = 'withHistoricalElementId',
    /** matches using the id directly against the single historically tagged named element */
    withoutHistoricalElementId = 'withoutHistoricalElementId',
    /** matches events that were tagged historically with a named element id */
    withSetHistoricalElementId = 'withSetHistoricalElementId',
    /** matches events that were not tagged historically with a named element id */
    withUnsetHistoricalElementId = 'withUnsetHistoricalElementId'
  }

  export function operator_oneof(m: ElementIdOperator): { opt: operator.withElementId, key: operator_keys.withElementId, val: RepeatedNamedElementValue } | { opt: operator.withHistoricalElementId, key: operator_keys.withHistoricalElementId, val: RepeatedNamedElementValue } | { opt: operator.withSetHistoricalElementId, key: operator_keys.withSetHistoricalElementId, val: NoneValue } | { opt: operator.withUnsetHistoricalElementId, key: operator_keys.withUnsetHistoricalElementId, val: NoneValue } | { opt: operator.withoutHistoricalElementId, key: operator_keys.withoutHistoricalElementId, val: RepeatedNamedElementValue } | null {
    if (m.withElementId != null) { return { opt: operator.withElementId, key: operator_keys.withElementId, val: m.withElementId } }
    if (m.withHistoricalElementId != null) { return { opt: operator.withHistoricalElementId, key: operator_keys.withHistoricalElementId, val: m.withHistoricalElementId } }
    if (m.withoutHistoricalElementId != null) { return { opt: operator.withoutHistoricalElementId, key: operator_keys.withoutHistoricalElementId, val: m.withoutHistoricalElementId } }
    if (m.withSetHistoricalElementId != null) { return { opt: operator.withSetHistoricalElementId, key: operator_keys.withSetHistoricalElementId, val: m.withSetHistoricalElementId } }
    if (m.withUnsetHistoricalElementId != null) { return { opt: operator.withUnsetHistoricalElementId, key: operator_keys.withUnsetHistoricalElementId, val: m.withUnsetHistoricalElementId } }
    return null;
  }
}

export interface CustomFieldStringOperator {
  equals?: CustomFieldRepeatedStringValue | null;
  notEquals?: CustomFieldRepeatedStringValue | null;
  startsWith?: CustomFieldRepeatedStringValue | null;
  endsWith?: CustomFieldRepeatedStringValue | null;
  substring?: CustomFieldRepeatedStringValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldStringOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    startsWith = 3,
    endsWith = 4,
    substring = 5,
    isSet = 6,
    isUnset = 7
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    substring = 'substring',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldStringOperator): { opt: operator.endsWith, key: operator_keys.endsWith, val: CustomFieldRepeatedStringValue } | { opt: operator.equals, key: operator_keys.equals, val: CustomFieldRepeatedStringValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: CustomFieldRepeatedStringValue } | { opt: operator.startsWith, key: operator_keys.startsWith, val: CustomFieldRepeatedStringValue } | { opt: operator.substring, key: operator_keys.substring, val: CustomFieldRepeatedStringValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.startsWith != null) { return { opt: operator.startsWith, key: operator_keys.startsWith, val: m.startsWith } }
    if (m.endsWith != null) { return { opt: operator.endsWith, key: operator_keys.endsWith, val: m.endsWith } }
    if (m.substring != null) { return { opt: operator.substring, key: operator_keys.substring, val: m.substring } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldStringsOperator {
  equals?: CustomFieldRepeatedStringValue | null;
  notEquals?: CustomFieldRepeatedStringValue | null;
  startsWith?: CustomFieldRepeatedStringValue | null;
  endsWith?: CustomFieldRepeatedStringValue | null;
  substring?: CustomFieldRepeatedStringValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldStringsOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    startsWith = 3,
    endsWith = 4,
    substring = 5,
    isSet = 6,
    isUnset = 7
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    substring = 'substring',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldStringsOperator): { opt: operator.endsWith, key: operator_keys.endsWith, val: CustomFieldRepeatedStringValue } | { opt: operator.equals, key: operator_keys.equals, val: CustomFieldRepeatedStringValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: CustomFieldRepeatedStringValue } | { opt: operator.startsWith, key: operator_keys.startsWith, val: CustomFieldRepeatedStringValue } | { opt: operator.substring, key: operator_keys.substring, val: CustomFieldRepeatedStringValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.startsWith != null) { return { opt: operator.startsWith, key: operator_keys.startsWith, val: m.startsWith } }
    if (m.endsWith != null) { return { opt: operator.endsWith, key: operator_keys.endsWith, val: m.endsWith } }
    if (m.substring != null) { return { opt: operator.substring, key: operator_keys.substring, val: m.substring } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldFloatOperator {
  equals?: CustomFieldRepeatedFloatValue | null;
  notEquals?: CustomFieldRepeatedFloatValue | null;
  lessThan?: CustomFieldFloatValue | null;
  greaterThan?: CustomFieldFloatValue | null;
  atMost?: CustomFieldFloatValue | null;
  atLeast?: CustomFieldFloatValue | null;
  range?: CustomFieldFloatRangeValue | null;
  notRange?: CustomFieldFloatRangeValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldFloatOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    lessThan = 3,
    greaterThan = 4,
    atMost = 5,
    atLeast = 6,
    range = 9,
    notRange = 10,
    isSet = 7,
    isUnset = 8
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    lessThan = 'lessThan',
    greaterThan = 'greaterThan',
    atMost = 'atMost',
    atLeast = 'atLeast',
    range = 'range',
    notRange = 'notRange',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldFloatOperator): { opt: operator.atLeast, key: operator_keys.atLeast, val: CustomFieldFloatValue } | { opt: operator.atMost, key: operator_keys.atMost, val: CustomFieldFloatValue } | { opt: operator.equals, key: operator_keys.equals, val: CustomFieldRepeatedFloatValue } | { opt: operator.greaterThan, key: operator_keys.greaterThan, val: CustomFieldFloatValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.lessThan, key: operator_keys.lessThan, val: CustomFieldFloatValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: CustomFieldRepeatedFloatValue } | { opt: operator.notRange, key: operator_keys.notRange, val: CustomFieldFloatRangeValue } | { opt: operator.range, key: operator_keys.range, val: CustomFieldFloatRangeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.lessThan != null) { return { opt: operator.lessThan, key: operator_keys.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, key: operator_keys.greaterThan, val: m.greaterThan } }
    if (m.atMost != null) { return { opt: operator.atMost, key: operator_keys.atMost, val: m.atMost } }
    if (m.atLeast != null) { return { opt: operator.atLeast, key: operator_keys.atLeast, val: m.atLeast } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldFloatsOperator {
  equals?: CustomFieldRepeatedFloatValue | null;
  notEquals?: CustomFieldRepeatedFloatValue | null;
  lessThan?: CustomFieldFloatValue | null;
  greaterThan?: CustomFieldFloatValue | null;
  atMost?: CustomFieldFloatValue | null;
  atLeast?: CustomFieldFloatValue | null;
  range?: CustomFieldFloatRangeValue | null;
  notRange?: CustomFieldFloatRangeValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldFloatsOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    lessThan = 3,
    greaterThan = 4,
    atMost = 5,
    atLeast = 6,
    range = 9,
    notRange = 10,
    isSet = 7,
    isUnset = 8
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    lessThan = 'lessThan',
    greaterThan = 'greaterThan',
    atMost = 'atMost',
    atLeast = 'atLeast',
    range = 'range',
    notRange = 'notRange',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldFloatsOperator): { opt: operator.atLeast, key: operator_keys.atLeast, val: CustomFieldFloatValue } | { opt: operator.atMost, key: operator_keys.atMost, val: CustomFieldFloatValue } | { opt: operator.equals, key: operator_keys.equals, val: CustomFieldRepeatedFloatValue } | { opt: operator.greaterThan, key: operator_keys.greaterThan, val: CustomFieldFloatValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.lessThan, key: operator_keys.lessThan, val: CustomFieldFloatValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: CustomFieldRepeatedFloatValue } | { opt: operator.notRange, key: operator_keys.notRange, val: CustomFieldFloatRangeValue } | { opt: operator.range, key: operator_keys.range, val: CustomFieldFloatRangeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.lessThan != null) { return { opt: operator.lessThan, key: operator_keys.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, key: operator_keys.greaterThan, val: m.greaterThan } }
    if (m.atMost != null) { return { opt: operator.atMost, key: operator_keys.atMost, val: m.atMost } }
    if (m.atLeast != null) { return { opt: operator.atLeast, key: operator_keys.atLeast, val: m.atLeast } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldIntOperator {
  equals?: CustomFieldRepeatedIntValue | null;
  notEquals?: CustomFieldRepeatedIntValue | null;
  lessThan?: CustomFieldIntValue | null;
  greaterThan?: CustomFieldIntValue | null;
  atMost?: CustomFieldIntValue | null;
  atLeast?: CustomFieldIntValue | null;
  range?: CustomFieldIntRangeValue | null;
  notRange?: CustomFieldIntRangeValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldIntOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    lessThan = 3,
    greaterThan = 4,
    atMost = 5,
    atLeast = 6,
    range = 9,
    notRange = 10,
    isSet = 7,
    isUnset = 8
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    lessThan = 'lessThan',
    greaterThan = 'greaterThan',
    atMost = 'atMost',
    atLeast = 'atLeast',
    range = 'range',
    notRange = 'notRange',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldIntOperator): { opt: operator.atLeast, key: operator_keys.atLeast, val: CustomFieldIntValue } | { opt: operator.atMost, key: operator_keys.atMost, val: CustomFieldIntValue } | { opt: operator.equals, key: operator_keys.equals, val: CustomFieldRepeatedIntValue } | { opt: operator.greaterThan, key: operator_keys.greaterThan, val: CustomFieldIntValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.lessThan, key: operator_keys.lessThan, val: CustomFieldIntValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: CustomFieldRepeatedIntValue } | { opt: operator.notRange, key: operator_keys.notRange, val: CustomFieldIntRangeValue } | { opt: operator.range, key: operator_keys.range, val: CustomFieldIntRangeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.lessThan != null) { return { opt: operator.lessThan, key: operator_keys.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, key: operator_keys.greaterThan, val: m.greaterThan } }
    if (m.atMost != null) { return { opt: operator.atMost, key: operator_keys.atMost, val: m.atMost } }
    if (m.atLeast != null) { return { opt: operator.atLeast, key: operator_keys.atLeast, val: m.atLeast } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldIntsOperator {
  equals?: CustomFieldRepeatedIntValue | null;
  notEquals?: CustomFieldRepeatedIntValue | null;
  lessThan?: CustomFieldIntValue | null;
  greaterThan?: CustomFieldIntValue | null;
  atMost?: CustomFieldIntValue | null;
  atLeast?: CustomFieldIntValue | null;
  range?: CustomFieldIntRangeValue | null;
  notRange?: CustomFieldIntRangeValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldIntsOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    lessThan = 3,
    greaterThan = 4,
    atMost = 5,
    atLeast = 6,
    range = 9,
    notRange = 10,
    isSet = 7,
    isUnset = 8
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    lessThan = 'lessThan',
    greaterThan = 'greaterThan',
    atMost = 'atMost',
    atLeast = 'atLeast',
    range = 'range',
    notRange = 'notRange',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldIntsOperator): { opt: operator.atLeast, key: operator_keys.atLeast, val: CustomFieldIntValue } | { opt: operator.atMost, key: operator_keys.atMost, val: CustomFieldIntValue } | { opt: operator.equals, key: operator_keys.equals, val: CustomFieldRepeatedIntValue } | { opt: operator.greaterThan, key: operator_keys.greaterThan, val: CustomFieldIntValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.lessThan, key: operator_keys.lessThan, val: CustomFieldIntValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: CustomFieldRepeatedIntValue } | { opt: operator.notRange, key: operator_keys.notRange, val: CustomFieldIntRangeValue } | { opt: operator.range, key: operator_keys.range, val: CustomFieldIntRangeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.lessThan != null) { return { opt: operator.lessThan, key: operator_keys.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, key: operator_keys.greaterThan, val: m.greaterThan } }
    if (m.atMost != null) { return { opt: operator.atMost, key: operator_keys.atMost, val: m.atMost } }
    if (m.atLeast != null) { return { opt: operator.atLeast, key: operator_keys.atLeast, val: m.atLeast } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldBoolOperator {
  equals?: CustomFieldBoolValue | null;
  notEquals?: CustomFieldBoolValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldBoolOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    isSet = 3,
    isUnset = 4
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldBoolOperator): { opt: operator.equals, key: operator_keys.equals, val: CustomFieldBoolValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: CustomFieldBoolValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldBoolsOperator {
  equals?: CustomFieldBoolValue | null;
  notEquals?: CustomFieldBoolValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldBoolsOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    isSet = 3,
    isUnset = 4
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldBoolsOperator): { opt: operator.equals, key: operator_keys.equals, val: CustomFieldBoolValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: CustomFieldBoolValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldDateOperator {
  after?: CustomFieldDateValue | null;
  before?: CustomFieldDateValue | null;
  range?: CustomFieldDateRangeValue | null;
  notRange?: CustomFieldDateRangeValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldDateOperator {
  export enum operator {
    after = 1,
    before = 2,
    range = 3,
    notRange = 4,
    isSet = 5,
    isUnset = 6
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    after = 'after',
    before = 'before',
    range = 'range',
    notRange = 'notRange',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldDateOperator): { opt: operator.after, key: operator_keys.after, val: CustomFieldDateValue } | { opt: operator.before, key: operator_keys.before, val: CustomFieldDateValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.notRange, key: operator_keys.notRange, val: CustomFieldDateRangeValue } | { opt: operator.range, key: operator_keys.range, val: CustomFieldDateRangeValue } | null {
    if (m.after != null) { return { opt: operator.after, key: operator_keys.after, val: m.after } }
    if (m.before != null) { return { opt: operator.before, key: operator_keys.before, val: m.before } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface CustomFieldDatesOperator {
  after?: CustomFieldDateValue | null;
  before?: CustomFieldDateValue | null;
  range?: CustomFieldDateRangeValue | null;
  notRange?: CustomFieldDateRangeValue | null;
  isSet?: CustomFieldIsSetValue | null;
  isUnset?: CustomFieldIsSetValue | null;
}

export namespace CustomFieldDatesOperator {
  export enum operator {
    after = 1,
    before = 2,
    range = 3,
    notRange = 4,
    isSet = 5,
    isUnset = 6
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    after = 'after',
    before = 'before',
    range = 'range',
    notRange = 'notRange',
    isSet = 'isSet',
    isUnset = 'isUnset'
  }

  export function operator_oneof(m: CustomFieldDatesOperator): { opt: operator.after, key: operator_keys.after, val: CustomFieldDateValue } | { opt: operator.before, key: operator_keys.before, val: CustomFieldDateValue } | { opt: operator.isSet, key: operator_keys.isSet, val: CustomFieldIsSetValue } | { opt: operator.isUnset, key: operator_keys.isUnset, val: CustomFieldIsSetValue } | { opt: operator.notRange, key: operator_keys.notRange, val: CustomFieldDateRangeValue } | { opt: operator.range, key: operator_keys.range, val: CustomFieldDateRangeValue } | null {
    if (m.after != null) { return { opt: operator.after, key: operator_keys.after, val: m.after } }
    if (m.before != null) { return { opt: operator.before, key: operator_keys.before, val: m.before } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    if (m.isSet != null) { return { opt: operator.isSet, key: operator_keys.isSet, val: m.isSet } }
    if (m.isUnset != null) { return { opt: operator.isUnset, key: operator_keys.isUnset, val: m.isUnset } }
    return null;
  }
}

export interface SignedUpOperator {
  signedUp?: BoolValue | null;
}

export namespace SignedUpOperator {
  export enum operator {
    signedUp = 1
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    signedUp = 'signedUp'
  }

  export function operator_oneof(m: SignedUpOperator): { opt: operator.signedUp, key: operator_keys.signedUp, val: BoolValue } | null {
    if (m.signedUp != null) { return { opt: operator.signedUp, key: operator_keys.signedUp, val: m.signedUp } }
    return null;
  }
}

export interface DateOperator {
  after?: DateValue | null;
  before?: DateValue | null;
  range?: DateRangeValue | null;
  notRange?: DateRangeValue | null;
}

export namespace DateOperator {
  export enum operator {
    after = 1,
    before = 2,
    range = 3,
    notRange = 4
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    after = 'after',
    before = 'before',
    range = 'range',
    notRange = 'notRange'
  }

  export function operator_oneof(m: DateOperator): { opt: operator.after, key: operator_keys.after, val: DateValue } | { opt: operator.before, key: operator_keys.before, val: DateValue } | { opt: operator.notRange, key: operator_keys.notRange, val: DateRangeValue } | { opt: operator.range, key: operator_keys.range, val: DateRangeValue } | null {
    if (m.after != null) { return { opt: operator.after, key: operator_keys.after, val: m.after } }
    if (m.before != null) { return { opt: operator.before, key: operator_keys.before, val: m.before } }
    if (m.range != null) { return { opt: operator.range, key: operator_keys.range, val: m.range } }
    if (m.notRange != null) { return { opt: operator.notRange, key: operator_keys.notRange, val: m.notRange } }
    return null;
  }
}

export interface DefinedEventOperator {
  withId?: StringValue | null;
  /** matches using the id directly against the historically tagged id */
  withHistoricalId?: StringValue | null;
  /** (no) matches using any id directly against the historically tagged id */
  withoutHistoricalId?: RepeatedStringValue | null;
  /** matches events that were tagged historically with a defined event id */
  withSetHistoricalId?: NoneValue | null;
  /** (no) matches for events that were tagged historically with a defined event id */
  withoutSetHistoricalId?: NoneValue | null;
}

export namespace DefinedEventOperator {
  export enum operator {
    withId = 1,
    /** matches using the id directly against the historically tagged id */
    withHistoricalId = 2,
    /** (no) matches using any id directly against the historically tagged id */
    withoutHistoricalId = 4,
    /** matches events that were tagged historically with a defined event id */
    withSetHistoricalId = 3,
    /** (no) matches for events that were tagged historically with a defined event id */
    withoutSetHistoricalId = 5
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    withId = 'withId',
    /** matches using the id directly against the historically tagged id */
    withHistoricalId = 'withHistoricalId',
    /** (no) matches using any id directly against the historically tagged id */
    withoutHistoricalId = 'withoutHistoricalId',
    /** matches events that were tagged historically with a defined event id */
    withSetHistoricalId = 'withSetHistoricalId',
    /** (no) matches for events that were tagged historically with a defined event id */
    withoutSetHistoricalId = 'withoutSetHistoricalId'
  }

  export function operator_oneof(m: DefinedEventOperator): { opt: operator.withHistoricalId, key: operator_keys.withHistoricalId, val: StringValue } | { opt: operator.withId, key: operator_keys.withId, val: StringValue } | { opt: operator.withSetHistoricalId, key: operator_keys.withSetHistoricalId, val: NoneValue } | { opt: operator.withoutHistoricalId, key: operator_keys.withoutHistoricalId, val: RepeatedStringValue } | { opt: operator.withoutSetHistoricalId, key: operator_keys.withoutSetHistoricalId, val: NoneValue } | null {
    if (m.withId != null) { return { opt: operator.withId, key: operator_keys.withId, val: m.withId } }
    if (m.withHistoricalId != null) { return { opt: operator.withHistoricalId, key: operator_keys.withHistoricalId, val: m.withHistoricalId } }
    if (m.withoutHistoricalId != null) { return { opt: operator.withoutHistoricalId, key: operator_keys.withoutHistoricalId, val: m.withoutHistoricalId } }
    if (m.withSetHistoricalId != null) { return { opt: operator.withSetHistoricalId, key: operator_keys.withSetHistoricalId, val: m.withSetHistoricalId } }
    if (m.withoutSetHistoricalId != null) { return { opt: operator.withoutSetHistoricalId, key: operator_keys.withoutSetHistoricalId, val: m.withoutSetHistoricalId } }
    return null;
  }
}

export interface SpecEventOperator {
  specId?: StringValue | null;
}

export namespace SpecEventOperator {
  export enum operator {
    specId = 1
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    specId = 'specId'
  }

  export function operator_oneof(m: SpecEventOperator): { opt: operator.specId, key: operator_keys.specId, val: StringValue } | null {
    if (m.specId != null) { return { opt: operator.specId, key: operator_keys.specId, val: m.specId } }
    return null;
  }
}

export interface PinchGestureOperator {
  equals?: PinchGestureTypeValue | null;
}

export namespace PinchGestureOperator {
  export enum operator {
    equals = 1
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals'
  }

  export function operator_oneof(m: PinchGestureOperator): { opt: operator.equals, key: operator_keys.equals, val: PinchGestureTypeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    return null;
  }
}

export interface SeenVisibilityOperator {
  equals?: SeenVisibilityTypeValue | null;
}

export namespace SeenVisibilityOperator {
  export enum operator {
    equals = 1
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals'
  }

  export function operator_oneof(m: SeenVisibilityOperator): { opt: operator.equals, key: operator_keys.equals, val: SeenVisibilityTypeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    return null;
  }
}

export interface BoolOperator {
  equals?: BoolValue | null;
  notEquals?: BoolValue | null;
}

export namespace BoolOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: BoolOperator): { opt: operator.equals, key: operator_keys.equals, val: BoolValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: BoolValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface ErrorClickTypeOperator {
  equals?: ErrorClickTypeValue | null;
  notEquals?: ErrorClickTypeValue | null;
}

export namespace ErrorClickTypeOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: ErrorClickTypeOperator): { opt: operator.equals, key: operator_keys.equals, val: ErrorClickTypeValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: ErrorClickTypeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface DatalossOperator {
  any?: NoneValue | null;
  elem?: NoneValue | null;
  inputElem?: NoneValue | null;
  navUrl?: NoneValue | null;
  netUrl?: NoneValue | null;
  reqHeader?: NoneValue | null;
  rspHeader?: NoneValue | null;
  reqBody?: NoneValue | null;
  rspBody?: NoneValue | null;
  exception?: NoneValue | null;
  log?: NoneValue | null;
}

export namespace DatalossOperator {
  export enum operator {
    any = 1,
    elem = 2,
    inputElem = 3,
    navUrl = 4,
    netUrl = 5,
    reqHeader = 6,
    rspHeader = 7,
    reqBody = 8,
    rspBody = 9,
    exception = 10,
    log = 11
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    any = 'any',
    elem = 'elem',
    inputElem = 'inputElem',
    navUrl = 'navUrl',
    netUrl = 'netUrl',
    reqHeader = 'reqHeader',
    rspHeader = 'rspHeader',
    reqBody = 'reqBody',
    rspBody = 'rspBody',
    exception = 'exception',
    log = 'log'
  }

  export function operator_oneof(m: DatalossOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.elem, key: operator_keys.elem, val: NoneValue } | { opt: operator.exception, key: operator_keys.exception, val: NoneValue } | { opt: operator.inputElem, key: operator_keys.inputElem, val: NoneValue } | { opt: operator.log, key: operator_keys.log, val: NoneValue } | { opt: operator.navUrl, key: operator_keys.navUrl, val: NoneValue } | { opt: operator.netUrl, key: operator_keys.netUrl, val: NoneValue } | { opt: operator.reqBody, key: operator_keys.reqBody, val: NoneValue } | { opt: operator.reqHeader, key: operator_keys.reqHeader, val: NoneValue } | { opt: operator.rspBody, key: operator_keys.rspBody, val: NoneValue } | { opt: operator.rspHeader, key: operator_keys.rspHeader, val: NoneValue } | null {
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    if (m.elem != null) { return { opt: operator.elem, key: operator_keys.elem, val: m.elem } }
    if (m.inputElem != null) { return { opt: operator.inputElem, key: operator_keys.inputElem, val: m.inputElem } }
    if (m.navUrl != null) { return { opt: operator.navUrl, key: operator_keys.navUrl, val: m.navUrl } }
    if (m.netUrl != null) { return { opt: operator.netUrl, key: operator_keys.netUrl, val: m.netUrl } }
    if (m.reqHeader != null) { return { opt: operator.reqHeader, key: operator_keys.reqHeader, val: m.reqHeader } }
    if (m.rspHeader != null) { return { opt: operator.rspHeader, key: operator_keys.rspHeader, val: m.rspHeader } }
    if (m.reqBody != null) { return { opt: operator.reqBody, key: operator_keys.reqBody, val: m.reqBody } }
    if (m.rspBody != null) { return { opt: operator.rspBody, key: operator_keys.rspBody, val: m.rspBody } }
    if (m.exception != null) { return { opt: operator.exception, key: operator_keys.exception, val: m.exception } }
    if (m.log != null) { return { opt: operator.log, key: operator_keys.log, val: m.log } }
    return null;
  }
}

export interface DatalossTypeOperator {
  equals?: DatalossTypeValue | null;
  notEquals?: DatalossTypeValue | null;
}

export namespace DatalossTypeOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: DatalossTypeOperator): { opt: operator.equals, key: operator_keys.equals, val: DatalossTypeValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: DatalossTypeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface DatalossOriginOperator {
  startsWith?: RepeatedStringValue | null;
}

export namespace DatalossOriginOperator {
  export enum operator {
    startsWith = 1
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    startsWith = 'startsWith'
  }

  export function operator_oneof(m: DatalossOriginOperator): { opt: operator.startsWith, key: operator_keys.startsWith, val: RepeatedStringValue } | null {
    if (m.startsWith != null) { return { opt: operator.startsWith, key: operator_keys.startsWith, val: m.startsWith } }
    return null;
  }
}

export interface SuspiciousActivityOperator {
  any?: NoneValue | null;
  equals?: SuspiciousActivityCategoryValue | null;
}

export namespace SuspiciousActivityOperator {
  export enum operator {
    any = 1,
    equals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    any = 'any',
    equals = 'equals'
  }

  export function operator_oneof(m: SuspiciousActivityOperator): { opt: operator.any, key: operator_keys.any, val: NoneValue } | { opt: operator.equals, key: operator_keys.equals, val: SuspiciousActivityCategoryValue } | null {
    if (m.any != null) { return { opt: operator.any, key: operator_keys.any, val: m.any } }
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    return null;
  }
}

export interface SuspiciousActivityTypeOperator {
  equals?: SuspiciousActivityTypeValue | null;
  notEquals?: SuspiciousActivityTypeValue | null;
}

export namespace SuspiciousActivityTypeOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: SuspiciousActivityTypeOperator): { opt: operator.equals, key: operator_keys.equals, val: SuspiciousActivityTypeValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: SuspiciousActivityTypeValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface SuspiciousActivityCategoryOperator {
  equals?: SuspiciousActivityCategoryValue | null;
  notEquals?: SuspiciousActivityCategoryValue | null;
}

export namespace SuspiciousActivityCategoryOperator {
  export enum operator {
    equals = 1,
    notEquals = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    equals = 'equals',
    notEquals = 'notEquals'
  }

  export function operator_oneof(m: SuspiciousActivityCategoryOperator): { opt: operator.equals, key: operator_keys.equals, val: SuspiciousActivityCategoryValue } | { opt: operator.notEquals, key: operator_keys.notEquals, val: SuspiciousActivityCategoryValue } | null {
    if (m.equals != null) { return { opt: operator.equals, key: operator_keys.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, key: operator_keys.notEquals, val: m.notEquals } }
    return null;
  }
}

export interface NoneOperator {
}
